import {
  API_MEMBERS_GET_ENDPOINT as registeredMembersUrl,
  API_REGISTEREDBIDDERS_GET_ENDPOINT as authorizedMembersUrl,
  API_UNIQUEMEMBERS_GET_ENDPOINT as uniqueMembersUrl,
} from '../../shared/constants';

export default (type) => {
  switch (type) {
    case 'UNIQUE':
      return {
        fn: uniqueMembersUrl,
        processData: async (res) => {
          const {
            data: {
              pagedUniqueRegisteredMembers: { items: data, totalItems },
            },
          } = res;
          return { data, totalItems };
        },
      };
    case 'REGISTERED':
      return {
        fn: registeredMembersUrl,
        processData: async (res) => {
          const {
            data: {
              pagedRegisteredMembers: { items: data, totalItems },
            },
          } = res;
          return { data, totalItems };
        },
      };
    case 'AUTHORIZED':
      return {
        fn: authorizedMembersUrl,
        processData: async (res) => {
          const {
            data: {
              pagedRegisteredBidders: { items: data, totalItems },
            },
          } = res;
          return { data, totalItems };
        },
      };
    default:
      throw new Error('Invalid member type passed to members reducer');
  }
};
